import { getUtcDate } from "../date";
import { getDefaultDishOptions, isDishComplete } from "./dish";

export const createLunch = (title, description, company, companyUrl, dishes, endDate) => ({
    title,
    description,
    company,
    companyUrl,
    options: dishes.map(el => ({
        name: el.name,
        description: el.description,
        imageUrl: el.imageUrl,
        options: el.options
    })),
    endDate: getUtcDate(endDate),
});

export const findDishByName = (options, dishName) => options.find(({name}) => name === dishName);

export const getDishOptionsByName = (options, dishName) => {
    const dish = findDishByName(options, dishName);
    return dish && dish.options;
}

export const getDefaultDishOptionsByName = (options, dishName) => {
    const newDishOptions = getDishOptionsByName(options, dishName);
    return getDefaultDishOptions(newDishOptions);
}

export const areFieldsFilled = (
    title,
    description,
    company,
    companyUrl,
    endDate
) => {

    return title && description && company && companyUrl && endDate;
}

export const validateLunch = ({
                                  title,
                                  description,
                                  company,
                                  companyUrl,
                                  endDate,
                                  options
                              }) => {
    const areFieldsValid = areFieldsFilled(title, description, company, companyUrl, endDate);
    if (!areFieldsValid) {
        throw Error('Lunch info is not completed.');
    }
    const areOptionsValid = !options.find((option) => !isDishComplete(option));
    if (!areOptionsValid) {
        throw Error('Lunch dishes are not completed.');
    }
    return !!areFieldsFilled && areOptionsValid;
}
